/*

Preisanzeige mit Warenkorb-Button

 */

import { Trans } from '@lingui/macro'
import { useEffect, useState } from 'react'
import './BuyBox.css'
import {logDebug} from "./helpers/general";

function BuyBoxB2C ({ selected }) {

    const [configData, setConfigData] = useState({price: ''})

    const [amount, setAmount] = useState(1)     // Menge der zu bestellenden Betten in der aktuellen Konfiguration
    function updateAmount(e) {
        setAmount(e.target.value);
    }

    function updatePrice () {
        // Fragt den aktuellen Preis beim Shop an
        /*
        TODO ...
        */
    }
    useEffect(() => {
        if (selected) {
            updatePrice()
        }
    }, [selected])

    function addToBasket() {
        // Legt die gewählte Konfiguration in der gewünschten Menge in den Warenkorb
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'sw-access-key': 'SWSC9NICBULDTWBHM-IEKHRO1W',
                'accept': 'application/json'
            },
            body: JSON.stringify({
                items: [{
                    type: 'product',
                    referencedId: '12345678901234567890123456789012',
                    label: 'Konfiguriertes Bett',   // TODO Bei B2B setzt offenbar Oxid den Namen?
                    quantity: amount,
                    price: 1,
                    payload: selected
                }]
            })
        }
        fetch('https://www.fbf-home.de/store-api/checkout/cart/line-item', requestOptions)        // vorher herausfinden, ob Benutzer eingeloggt ist?
            .then(/* TODO in den Shop springen */)
    }

    return (
        <footer className='buyBox'>
            <div className="totalPrice">&euro; {configData ? configData.price : ''}</div>
            <div className="text"><Trans>Gesamtpreis pro Bett exkl. MwSt.</Trans></div>
            <button className="btn cartBtn btnPrimary" onClick={addToBasket}><Trans>In den Warenkorb</Trans></button>
            <input type="text" name="amount" className="amount" defaultValue={amount} onChange={e => updateAmount(e)} />
        </footer>
    )

}

export default BuyBoxB2C
